<script setup lang="ts">
import { computed } from 'vue'
import useVuelidate from '@vuelidate/core'
import { minLength, required } from '@/validation'
import TextField from '@/components/input/TextField.vue'

defineEmits<{
  delete: []
}>()
const model = defineModel<string | undefined>({ required: false })
const modelRef = computed(() => model.value ?? '')
const validation = useVuelidate<string>({ required, length: minLength(1) }, modelRef)
</script>

<template>
  <text-field v-model="model" required :validation="validation">
    <template #append>
      <v-btn variant="flat" density="comfortable" icon="delete" @click="$emit('delete')" />
    </template>
  </text-field>
</template>

<style scoped lang="scss"></style>
